import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_INFO_TOPIC,
  GET_INFO_TOPICS,
  GET_INFO_TOPIC_BY_INFO_GROUP_ID,
  GET_INFO_TOPICS_STUDENT_FIRST_PAGE,
  GET_INFO_TOPICS_TEACHER_FIRST_PAGE,
  GET_RECENT_INFO_TOPICS_FOR_STUDENT,
  GET_RECENT_INFO_TOPICS_FOR_TEACHER,
  ADD_INFO_TOPIC,
  UPDATE_INFO_TOPIC,
  DELETE_INFO_TOPIC
} from '@/queries/modules/university-news/info-topic';

export async function getInfoTopics(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_INFO_TOPICS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.infoTopic;
    } else {
      context.commit('setSuccess', null);
      return data.getInfoTopics
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getInfoTopicsStudentFirstPage(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_INFO_TOPICS_STUDENT_FIRST_PAGE,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);
      return data.getInfoTopicsStudentFirstPage
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getInfoTopicsTeacherFirstPage(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_INFO_TOPICS_TEACHER_FIRST_PAGE,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);
      return data.getInfoTopicsTeacherFirstPage;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getRecentInfoTopicsForStudent(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_RECENT_INFO_TOPICS_FOR_STUDENT,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);
      return data.getRecentInfoTopicsForStudent;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getRecentInfoTopicsForTeacher(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_RECENT_INFO_TOPICS_FOR_TEACHER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);
      return data.getRecentInfoTopicsForTeacher;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getInfoTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_INFO_TOPIC,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.infoTopic;
    } else {
      context.commit('setSuccess', null);
      return data.getInfoTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getInfoTopicByInfoGroupID(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_INFO_TOPIC_BY_INFO_GROUP_ID,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);

      return data.getInfoTopicsByInfoGroup;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function addInfoTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_INFO_TOPIC,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', newItemSuccess(data.addInfoTopic.nameLocal));

      return data.addInfoTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateInfoTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_INFO_TOPIC,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      context.commit('setSuccess', updateItemSuccess(data.updateInfoTopic.nameLocal));

      return data.updateInfoTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteInfoTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_INFO_TOPIC,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', deleteItemSuccess(data.deleteInfoTopic.nameLocal));

      return data.deleteInfoTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

